import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  height: 100vh;

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 100%;
    height: 100vh;
  }

  & > div {
    position: absolute;
    height: 100vh;
    opacity: 0.8;
  }
`;

export const BgImg = styled.img`
  /* position: absolute; */
  width: 1610px;
  height: 100vh;
  z-index: -99;

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    width: 800px;
    height: 100%;
    /* left: calc(50% - 98.4rem / 2 + 9.05rem); */
  }
`;

export const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  & > div:nth-child(1) {
    font-weight: 300;
    font-size: 2.4rem;
    line-height: 4.2rem;

    letter-spacing: ${(props) => (props.language === "en" ? "0.3rem" : "0.925em")};
    padding: 0 20px;
  }
  & > div:nth-child(2) {
    margin-top: 1rem;
    font-weight: 700;
    font-size: 5.8rem;
    line-height: 10rem;
  }
  & > div:nth-child(3) {
    margin-top: 3rem;
    font-weight: 500;
    font-size: 2.4rem;
    line-height: 4.2rem;
    padding: 1rem 3rem;
    height: 6.4rem;
    border: 1px solid #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    & > div:nth-child(1) {
      font-size: 2rem;
      line-height: 3.6rem;
      letter-spacing: 0.22em;
    }
    & > div:nth-child(2) {
      font-size: 3.6rem;
      line-height: 4.3rem;
      width: 26.2rem;
    }
    & > div:nth-child(3) {
      width: 30.5rem;
      margin-top: 2.4rem;
      font-size: 1.6rem;
      line-height: 2.8rem;
      height: 7.6rem;
      flex-direction: column;
    }
  }
`;
